import Dropdown from "app/components/Dropdown";
import { ChangeColorIcon } from "app/components/Icons";
import menuIcon from "assets/svgs/ic_menu-grey.svg";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { actionsOptions } from "./data";
import { actions } from "./redux/slice";
import { isInsideRadixPopover } from "./helper";
import TagsColorPicker from "./TagsColorPicker";
import { ActionsProps } from "./types";

const Actions: React.FC<ActionsProps> = ({ selectedData, onDeleteRequest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { _id, color, title } = selectedData;
  const [showFixedColor, setShowFixedColor] = useState(false);
  const showFixedColorRef = useRef(false);
  showFixedColorRef.current = showFixedColor;

  const setColorPickerOpen: React.Dispatch<React.SetStateAction<boolean>> = (
    value,
  ) => {
    setShowFixedColor((prev) => {
      const open = typeof value === "function" ? value(prev) : value;
      showFixedColorRef.current = open;
      return open;
    });
  };

  const handleAction = (action: string) => {
    // dispatch(actions.setIsSelectedId(_id));
    dispatch(actions.setFormValue(selectedData));
    switch (action) {
      case "rename":
        dispatch(actions.setIsSelectedId(_id));
        break;
      case "remove":
        setIsOpen(false);
        onDeleteRequest?.();
        dispatch(actions.toggleDeleteModal(true));
        break;
      case "changeColor":
        setColorPickerOpen(true);
        return;
      default:
        // no-op
        break;
    }
    setIsOpen(false);
  };

  const handleOpenChange = (open: boolean) => {
    if (!open && showFixedColorRef.current) return;
    setIsOpen(open);
    if (!open) setColorPickerOpen(false);
  };

  const preventDismissForColorPicker = (e: Event) => {
    if (showFixedColorRef.current || isInsideRadixPopover(e.target)) {
      e.preventDefault();
    }
  };

  const handleColorUpdate = (val: string) => {
    dispatch(actions.setFormValue({ ...selectedData, color: val }));
    dispatch(
      actions.updateTags({
        callback: () => {
          setColorPickerOpen(false);
          setIsOpen(false);
        },
      }),
    );
  };

  const MenuItems = actionsOptions?.map((ele) => {
    if (ele)
      return {
        label: (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleAction(ele.actions);
            }}
            className="flex items-center justify-between gap-1.5 rounded-md transition-colors w-full "
          >
            <div className="flex items-center gap-1.5 ">
              {ele.icon}
              <span className="text-sm font-normal text-secondary">
                {ele.title}
              </span>
            </div>
          </button>
        ),
        action: () => {},
      };
    else return { label: "", action: () => {} };
  });
  return (
    <div className="relative ">
      <Dropdown
        open={isOpen}
        setOpen={handleOpenChange}
        onPointerDownOutside={preventDismissForColorPicker}
        onFocusOutside={preventDismissForColorPicker}
        trigger={
          <button
            type="button"
            onPointerDown={(e) => e.preventDefault()}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenChange(!isOpen);
            }}
            className={`w-6 h-6 flex items-center justify-center hover:bg-gray-100 focus:outline-none outline-none group-hover:opacity-100 opacity-0 ${
              isOpen ? "border border-black opacity-100 " : ""
            }`}
          >
            <img src={menuIcon} alt="menu" className="w-full h-full" />
          </button>
        }
        menuItems={MenuItems}
        align="end"
        className=" !w-fit min-w-[150px] "
        addSubContent={
          <TagsColorPicker
            trigger={
              <button
                className="w-full flex items-center h-[50px] px-4 gap-3 border-gray-100  "
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(actions.setFormValue(selectedData));
                  setColorPickerOpen(true);
                }}
              >
                <div className="flex items-center gap-1.5 ">
                  <ChangeColorIcon color="#79808A" />
                  <span className="text-sm font-normal text-secondary">
                    Change color
                  </span>
                </div>
              </button>
            }
            selectedColor={color}
            updateCode={handleColorUpdate}
            open={showFixedColor}
            setOpen={setColorPickerOpen}
          />
        }
      />
    </div>
  );
};

export default Actions;
